module.exports = __webpack_public_path__ + "img/icon2_highlight.4f4c1477.png";